import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.keys.js";
export function owlConfig(config) {
  config && window.owl && window.owl('config', config);
}
export function owlAddError(err, opts) {
  window.owl && window.owl('addError', err, opts);
}

/**
 * 
 * @param {string} msg 
 * @param {string} type 
 */
export function owlAddLog(msg) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  window.owl && window.owl('addLog', msg, type);
}

/* 
* @param {string} msg 
* @param {string} type 
*/
export function owlResetPv(opts) {
  window.owl && window.owl('resetPv', opts);
}

/**
 * 异常上报
 * @param name 异常名
 * @param error 异常信息
 * @param customInfo 自定义信息（可选）
 */
export var owlReportError = function owlReportError() {
  var _window$Owl;
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Error';
  var err = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var customInfo = arguments.length > 2 ? arguments[2] : undefined;
  // 拼接异常名
  try {
    err.message = err !== null && err !== void 0 && err.message ? "".concat(name, "-").concat(err.message) : name;
  } catch (_) {
    // catch 不需要处理
  }

  // 异常信息
  var info = {
    level: 'error'
  };

  // 增加自定义信息
  if (customInfo && Object.keys(customInfo).length > 0) info.tags = customInfo;

  // 异常上报
  window.Owl && ((_window$Owl = window.Owl) === null || _window$Owl === void 0 ? void 0 : _window$Owl.addError(err, info));
};

/**
 * 全局注册异常上报方法插件
 */
export var globalReportError = {
  install: function install(Vue) {
    Vue.prototype.$owlReportError = owlReportError;
  }
};